import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../Basemap.js";
import r from "../config.js";
import n from "../core/Collection.js";
import t from "../core/Logger.js";
import { normalize as a, Url as l, makeAbsolute as s } from "../core/urlUtils.js";
import { ensureType as i } from "../core/accessorSupport/ensureType.js";
import { esriBasemapDefinitions as o } from "./basemapDefinitions.js";
var c = t.getLogger("esri.support.basemapUtils");

function u() {
  return {};
}

function f(e) {
  for (var _r in e) {
    var _n = e[_r];
    !1 === (null == _n ? void 0 : _n.destroyed) && _n.destroy(), delete e[_r];
  }
}

function y(n, t) {
  var a;
  var l;

  if ("string" == typeof n) {
    if (!(n in o)) {
      var _e = Object.entries(o).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            e = _ref2[0],
            n = _ref2[1];

        return r.apiKey && !n.classic || !r.apiKey && n.classic && !n.deprecated;
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            e = _ref4[0];

        return "\"".concat(e, "\"");
      }).join(", ");

      return c.warn("Unable to find basemap definition for: ".concat(n, ". Try one of these: ").concat(_e)), null;
    }

    t && (l = t[n]), l || (l = e.fromId(n), t && (t[n] = l));
  } else l = i(e, n);

  return null != (a = l) && a.destroyed && (c.warn("The provided basemap is already destroyed", {
    basemap: l
  }), l = null), l;
}

function p(r) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = y(r);
  if (!t) return null;
  var a = new e({
    id: t.id,
    title: t.title,
    baseLayers: t.baseLayers.slice(),
    referenceLayers: t.referenceLayers.slice()
  });
  return n && (a.baseLayers = L(a.baseLayers, n.baseLayers), a.referenceLayers = L(a.referenceLayers, n.referenceLayers)), a.load().catch(function () {}), a.portalItem = t.portalItem, a;
}

function m(e) {
  var r = null;
  var n = g(e),
      t = !n.baseLayers.length;

  for (var _a in o) {
    var _e2 = U(n, j(o[_a]), {
      mustMatchReferences: t
    });

    if ("equal" === _e2) {
      r = _a;
      break;
    }

    "base-layers-equal" === _e2 && (r = _a);
  }

  return r;
}

function b(e, r) {
  if (e === r) return !0;
  return "equal" === U(g(e), g(r), {
    mustMatchReferences: !0
  });
}

function L(e, r) {
  var t = new n();
  return e.forEach(function (e) {
    var n = r.find(function (r) {
      return M(x(e), x(r));
    }) || e;
    t.some(function (e) {
      return e === n;
    }) ? t.push(e) : t.push(n);
  }), t;
}

function d(e) {
  return !(null == e || !e.baseLayers.concat(e.referenceLayers).some(S));
}

function S(e) {
  if (v(e.url)) return !0;
  if ("vector-tile" === e.type) for (var _r2 in e.sourceNameToSource) {
    var _n2 = e.sourceNameToSource[_r2];
    if (v(null == _n2 ? void 0 : _n2.sourceUrl)) return !0;
  }
  return !1;
}

var h = /^(basemaps|ibasemaps).*-api\.arcgis\.com$/i;

function v(e) {
  if (!e) return !1;
  var r = new l(s(e));
  return h.test(r.authority);
}

function g(e) {
  return e ? !e.loaded && e.resourceInfo ? j(e.resourceInfo.data) : {
    baseLayers: T(e.baseLayers),
    referenceLayers: T(e.referenceLayers)
  } : null;
}

function T(e) {
  return (n.isCollection(e) ? e.toArray() : e).map(x);
}

function x(e) {
  return {
    type: e.type,
    url: R("urlTemplate" in e && e.urlTemplate || e.url || "styleUrl" in e && e.styleUrl),
    minScale: "minScale" in e && null != e.minScale ? e.minScale : 0,
    maxScale: "maxScale" in e && null != e.maxScale ? e.maxScale : 0,
    opacity: null != e.opacity ? e.opacity : 1,
    visible: null == e.visible || !!e.visible
  };
}

function j(e) {
  return e ? {
    baseLayers: q(e.baseMapLayers.filter(function (e) {
      return !e.isReference;
    })),
    referenceLayers: q(e.baseMapLayers.filter(function (e) {
      return e.isReference;
    }))
  } : null;
}

function q(e) {
  return e.map(function (e) {
    return w(e);
  });
}

function w(e) {
  var r;

  switch (e.layerType) {
    case "VectorTileLayer":
      r = "vector-tile";
      break;

    case "ArcGISTiledMapServiceLayer":
      r = "tile";
      break;

    default:
      r = "unknown";
  }

  return {
    type: r,
    url: R(e.templateUrl || e.urlTemplate || e.styleUrl || e.url),
    minScale: null != e.minScale ? e.minScale : 0,
    maxScale: null != e.maxScale ? e.maxScale : 0,
    opacity: null != e.opacity ? e.opacity : 1,
    visible: null == e.visibility || !!e.visibility
  };
}

function U(e, r, n) {
  if (null != e != (null != r)) return "not-equal";
  if (!e) return "equal";
  if (!I(e.baseLayers, r.baseLayers)) return "not-equal";
  return I(e.referenceLayers, r.referenceLayers) ? "equal" : n.mustMatchReferences ? "not-equal" : "base-layers-equal";
}

function I(e, r) {
  if (e.length !== r.length) return !1;

  for (var _n3 = 0; _n3 < e.length; _n3++) {
    if (!M(e[_n3], r[_n3])) return !1;
  }

  return !0;
}

function M(e, r) {
  return e.type === r.type && e.url === r.url && e.minScale === r.minScale && e.maxScale === r.maxScale && e.visible === r.visible && e.opacity === r.opacity;
}

function R(e) {
  return e ? a(e).replace(/^\s*https?:/i, "").toLowerCase() : "";
}

export { p as clonePreservingTiledLayers, b as contentEquals, u as createCache, f as destroyCache, y as ensureType, m as getWellKnownBasemapId, d as hasDeveloperBasemapLayer, S as isDeveloperBasemapLayer };